document.addEventListener('DOMContentLoaded', () => {
  const dlg = document.getElementById('ez-dialog');
  const openBtn = document.getElementById('ez-open');
  const closeBtn = document.getElementById('ez-close');
  const checkBtn = document.getElementById('ez-check');
  const input = document.getElementById('ez-input');
  const msg = document.getElementById('ez-msg');

  const validPins = new Set([
    "110048","110024","110017","110016","110049","110092","201318",
    "201009","201301","110013","110014","110091","110096","201309",
    "201303","201307","110065","121001","121002","121003","121004",
    "121005","121008","121014","121007","121006","201304","110019",
    "201020","201305","201306","210313","201316"
  ]);

  openBtn.addEventListener('click', () => dlg.showModal());
  closeBtn.addEventListener('click', () => dlg.close());

  checkBtn.addEventListener('click', () => {
    const pin = input.value.trim();
    if (!/^\d{6}$/.test(pin)) {
      msg.textContent = "Enter valid pincode";
      msg.style.color = "orange";
      return;
    }
    if (validPins.has(pin)) {
      msg.textContent = "✅ We deliver to your area!";
      msg.style.color = "green";
    } else {
      msg.textContent = "❌ Sorry, we don't deliver here.";
      msg.style.color = "red";
    }
  });
});
